import type { DisplayConditionLogic } from '@epilot/journey-logic-commons/src/types/next'
import { LOGIC_ACTION } from '@epilot/journey-logic-commons/src/types/next'

import { LOW_PRIORITY } from '../constants'
import { Executor } from '../executor'
import type { DisplayConditionEvent, RuntimeContext } from '../types'

export class DisplayConditionExecutor extends Executor {
  constructor() {
    super(LOGIC_ACTION.DISPLAY_CONDITION)
  }

  priority() {
    return LOW_PRIORITY
  }

  event(
    logic: DisplayConditionLogic,
    _context?: RuntimeContext
  ): DisplayConditionEvent {
    return {
      source: logic.id,
      action: LOGIC_ACTION.DISPLAY_CONDITION,
      details: {
        targetBlock: logic.settings.targetBlock,
        visibilityAction: logic.settings.visibilityAction
      }
    }
  }
}
